import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {UseFormattedBannersParams} from '../../hooks/useFormattedBanners/types';
import {parseBanners} from '../../utils/parseBanners';

export const useParseBannersQuery = ({banners, isDesktop, isLoading}: UseFormattedBannersParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.BANNERS, banners, isDesktop, isLoading],
		queryFn: async () => parseBanners({banners, isDesktop}),
		enabled: !!banners && !isLoading,
		retry: 1,
	});
